import { render, staticRenderFns } from "./WorkTypeAttrs.vue?vue&type=template&id=6525d752"
import script from "./WorkTypeAttrs.vue?vue&type=script&lang=js"
export * from "./WorkTypeAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports